// import $ from 'dom7';
/*
	LAZYSIZES EVENTS:
		lazybeforesizes
		lazybeforeunveil
		lazyloaded
	LAZYSIZES CLASSES:
		lazyload
		lazyloading
		lazyloaded
*/
// handle img tags inside SVG foreignObject;
// NB: could also set the image xlink:href attr on lazybeforeunveil; but would require calculating src value https://github.com/aFarkas/lazysizes/issues/535#issuecomment-423287676
document.addEventListener('lazybeforesizes', function(event){
	const svgParent = event.target.closest('svg.lazyhold')
	if (svgParent && svgParent.length) {
		event.detail.width = svgParent[0].getBoundingClientRect().width || event.detail.width
	}
})
// add lazyholding class to lazyhold objects
document.addEventListener('lazybeforeunveil', function(event){
	const svgParent = event.target.closest('svg.lazyhold')
	if (svgParent && svgParent.length) { svgParent[0].classList.add('lazyholding') }
})
// add lazyholded class to lazyhold objects
document.addEventListener('lazyloaded', function(event){
	const svgParent = event.target.closest('svg.lazyhold')
	if (svgParent && svgParent.length) { svgParent[0].classList.add('lazyholded') }
})